import { FC, useEffect, ReactNode, useRef, useContext } from 'react';
import { ModalContentContext } from 'src/context/ModalContext/ModalContentContext';
import useBodyScrollLock from 'src/hooks/useBodyScrollLock';
interface IProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  children: ReactNode;
  onClickOutside?: () => void;
  onAnimationEnd?: () => void;
}
export const ModalScrollRoot: FC<IProps> = ({
  children,
  className,
  onAnimationEnd
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const {
    setScrollPercent,
    lockBodyScroll
  } = useContext(ModalContentContext);
  useEffect(() => {
    const calculateScrollPercentage = () => {
      if (rootRef.current) {
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = rootRef.current;
        const totalScrollableDistance = scrollHeight - clientHeight;
        const currentScrollPercentage = scrollTop / totalScrollableDistance * 100;
        setScrollPercent(currentScrollPercentage);
      }
    };
    const scrollElement = rootRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', calculateScrollPercentage);
      return () => {
        scrollElement.removeEventListener('scroll', calculateScrollPercentage);
      };
    }
  }, [setScrollPercent]);
  useBodyScrollLock(rootRef, lockBodyScroll);
  return <div ref={rootRef} className={className} data-scroll-id='modal-scroll-root' onAnimationEnd={onAnimationEnd} data-sentry-component="ModalScrollRoot" data-sentry-source-file="ModalScrollComponent.tsx">
      {children}
    </div>;
};